import PrizeAmount from "@components/utils/PrizeAmount";
import { useMegaShareStatus } from "@hooks/useMegaShareStatus";
import { motion } from "framer-motion";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import { amountVariant } from "../utils";

interface MegaShareAmountProps extends PropsWithClassName {
  zIndex: number;
}

/**
 * Taker bonus amount
 */
const MegaShareAmount = ({ className, zIndex }: MegaShareAmountProps) => {
  const { details: megaShareDetails } = useMegaShareStatus();
  const claimAmount = megaShareDetails?.takerClaimAmount;

  return (
    <motion.div
      className={cn("absolute bottom-[24px] start-1/2 -translate-start-1/2", className)}
      style={{ zIndex }}
      variants={amountVariant}
    >
      <div className={cn("h-[23px] w-fit overflow-hidden rounded-lg")}>
        <PrizeAmount
          amount={claimAmount}
          className="text-[22px] font-black leading-[22px]"
        />
      </div>
    </motion.div>
  );
};

export default MegaShareAmount;
